import { useTranslation } from 'react-i18next';
import styles from './CandidatesHeader.module.css';
import Text from '../../atoms/typography/Text';
import { ColorEnum, FontSizeEnum } from '../../enums';
import { CheckboxInput } from '../../molecules/checkbox-input';
import { useState } from 'react';
import BulkActionDropdownNew from '../bulk-action-dropdown/BulkActionDropdownNew';

const CandidatesHeader = () => {
    const { t } = useTranslation();

    const [shouldSelectAll, setShouldSelectAll] = useState<boolean>(false);

    const handleCheckboxClick = () => {
        setShouldSelectAll(!shouldSelectAll);

        BulkActionDropdownNew.setShouldSelectAll(!shouldSelectAll);
    }

    return (
        <tr className={styles.candidatesHeader}>
            <td className={styles.candidate}>
                <CheckboxInput
                    name='selectAllCandidates'
                    onClick={handleCheckboxClick}
                    checked={shouldSelectAll}
                />
                <Text
                    size={FontSizeEnum.Sm}
                    color={ColorEnum.Gray500}
                >
                    {t('candidate.table.title.candidate')}
                </Text>
            </td>
            <td>
                <Text
                    size={FontSizeEnum.Sm}
                    color={ColorEnum.Gray500}
                >
                    {t('candidate.table.title.reacted')}
                </Text>
            </td>
            <td>
                <Text
                    size={FontSizeEnum.Sm}
                    color={ColorEnum.Gray500}
                >
                    {t('candidate.table.title.extra.information')}
                </Text>
            </td>
            <td></td>
        </tr>
    )
}

export default CandidatesHeader;
